import { Input } from "@/Components/Form/Input"
import { CountrySelect } from "@/NewComponents/CountrySelect"
import { FormPhoneInput } from "@/NewComponents/PhoneInput"
import { VALID_EMAIL, VALID_PASSWORD, VALID_PHONE } from "@usher/pe-client-front-end-lib"
import { useIntl } from "react-intl"
import { Fragment } from "react/jsx-runtime"
import "./style.css"

interface Props {
  isTablet: boolean
  forCard: boolean
}
export const CorporateForm = ({ isTablet, forCard }: Props) => {
  const intl = useIntl()
  const order = (desktop: number, tablet: number) => (isTablet ? tablet : desktop)
  return (
    <Fragment>
      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "company_name" })}
        name="company_name"
        required
        style={{ order: 1 }}
      />
      <div style={{ order: order(2, 7) }}>
        <CountrySelect
          isDark={forCard}
          name="country_code"
          required
          label={intl.formatMessage({ id: "company_register_country" })}
        />
      </div>
      <Input
        dark={forCard}
        rules={VALID_EMAIL}
        label={intl.formatMessage({ id: "company_email" })}
        type="email"
        isEmail
        name="email"
        required
        style={{ order: order(3, 2) }}
      />

      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "state" })}
        name="state"
        required
        style={{ order: order(4, 8) }}
      />
      <div style={{ order: order(5, 4) }}>
        <FormPhoneInput
          dark={forCard}
          label={intl.formatMessage({ id: "phone" })}
          firstCountries={["US", "GB"]}
          defaultCountry="US"
          name="phone"
          required
          rules={{ ...VALID_PHONE, minLength: undefined, maxLength: undefined }}
        />
      </div>
      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "business_website" })}
        name="site"
        required
        style={{ order: order(forCard ? 5 : 8, 8) }}
      />

      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "city" })}
        name="city"
        required
        style={{ order: order(7, 10) }}
      />

      <Input
        dark={forCard}
        rules={VALID_PASSWORD}
        label={intl.formatMessage({ id: "pass" })}
        type="password"
        name="password"
        required
        style={{ order: order(10, 5) }}
      />
      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "saddress" })}
        name="address"
        required
        style={{ order: 9 }}
      />
      <Input
        dark={forCard}
        rules={VALID_PASSWORD}
        label={intl.formatMessage({ id: "cpass" })}
        type="password"
        name="password2"
        required
        style={{ order: order(12, 6) }}
      />
      <Input
        dark={forCard}
        label={intl.formatMessage({ id: "apt" })}
        name="address2"
        required
        style={{ order: 11 }}
      />
      <Input
        style={{ order: 15 }}
        dark={forCard}
        label={intl.formatMessage({ id: "zip" })}
        name="zip"
        required
      />
    </Fragment>
  )
}
